export default "__VITE_ASSET__559c5031__"